<template>
  <div id="detailPage" class="detailPage">
    <div class="titleBox">
      <p class="title">基础信息</p>
    </div>
    <ul class="ulBox clearFloat">
      <li>
        <div class="left">工单号：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.aufnr ? DetailData.aufnr : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">工单类型：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.auart ? DetailData.auart : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">产品物料：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.matnr ? DetailData.matnr : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">工厂型号：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.model ? DetailData.model : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">销售订单：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.kdauf ? DetailData.kdauf : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">订单行号：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.kdpos ? DetailData.kdpos : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">工单数量：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.psmng }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">入库数量：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.wemng }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">工厂代码：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.werks ? DetailData.werks : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">工厂名称：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.wektx ? DetailData.wektx : "-" }}
          </span>
        </div>
      </li>
      <li class="blockLi">
        <div class="left">物料描述：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.maktx ? DetailData.maktx : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">客户代码：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.kunnr ? DetailData.kunnr : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">客户名称：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.vkorg ? DetailData.vkorg : "(客户名称同步失败)" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">基本日期：</div>
        <div class="right">
          <span class="value">{{ DetailData.gstrp ? DetailData.gstrp.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3') : "-" }} 至 {{ DetailData.gltrp ? DetailData.gltrp.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3') : "-" }}</span>
        </div>
      </li>
      <li>
        <div class="left">业务员：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.ktonr ? DetailData.ktonr.replace(/(\s)/, '$1(')+")" : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">创建时间：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.erdat ? DetailData.erdat.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3') : "-" }}
            {{ DetailData.ertim ? DetailData.ertim.replace(/(\d{2})(\d{2})(\d{2})/g, '$1:$2:$3') : "" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">工单状态：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.txt04 ? DetailData.txt04 : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">最后同步时间：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.lastUpdateDateTime ? DetailData.lastUpdateDateTime : "-" }}
          </span>
        </div>
      </li>
      <li>
        <div class="left">修改次数：</div>
        <div class="right">
          <span class="value">
            {{ DetailData.ver }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  apiSapDetail, 
} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
  },
  components: {
    
  },
  data() {
    return {
      DetailData: {},
      SNData:[],
      pullDownData: {
        productOrderList: [],
      },
      dialogVisible: false,
      dialogTitle: "",
      dialogForm: {
      },
      dialogRules: {
        minBuild: [
          { required: true, message: "版本号不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
      fileText: "未选择任何文件",
    };
  },
  methods: {
    // 详情
    async detail(callback) {
      const res = await apiSapDetail({
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.DetailData = res.data;
        this.$parent.orderStatus = (res.data ? res.data.txt04 : null);
        if (callback) callback();
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .reCheck {
    color: #f56c6c; font-weight: bold; font-size: 16px;
  }
</style>
